<template>
  <div id="variables">
    <div class="d-flex">
      <div v-if="selectedDataset" class="star-icon" @click="toggleFavorite(selectedDataset)">
        <icon-base
          style="margin-left: 45px;"
          :iconStroke="
            favoriteDatasets.some((favorite) => favorite.id === selectedDataset.id)
              ? 'var(--flame)'
              : 'rgb(158, 167, 172)'
          "
          :iconColor="favoriteDatasets.some((favorite) => favorite.id === selectedDataset.id) ? 'var(--flame)' : 'none'"
          width="14"
          height="14"
          ><icon-star
        /></icon-base>
      </div>
      <h3 class="data-name-ref" :class="selectedDataset ? '' : 'data-name-ref-title'">
        {{ selectedDataset ? selectedDataset.referenceName : $t("variables.example") }}
      </h3>
    </div>

    <div class="settings-panel-area-header d-flex">
      <h4 class="flex-grow-1">{{ $t("variables.header") }}</h4>
    </div>

    <div class="variables" slot="content">
      <div class="filter-variables-wrap">
        <div class="filter-variables-icon">
          <i class="fa-light fa-search"></i>
        </div>
        <div class="search-wrap">
          <input
            class="filter-variables"
            :placeholder="$t('variables.search-ph')"
            v-model="filter"
            @input="onFilterChange(filter)"
          />
          <div @click="onEraseFilter(filter)" v-if="eraser"><i class="close-icon fas fa-times"></i></div>
        </div>
      </div>
      <div
        class="custom-scrollbar hide-bottom-scrollbar variables-in-use-wrapper"
      >
      
        <div v-for="(count, name) in variablesInTemplate" :key="name">
          <variable-in-use-selector
            v-if="isDemo && demoIsOther && variantVariations.some((v) => v.name == name)"
            :count="count"
            :variable="$store.getters.combinedVariables[name]"
            :variations="variantVariations.find((v) => v.name == name)"  
            v-show="name.indexOf(filter) > -1"
          />
          <variable-in-use
            v-else
            :count="count"
            :variable="$store.getters.combinedVariables[name]"
            v-show="name.indexOf(filter) > -1 && !demoIsOther"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const variations = require("@/assets/data/variableVariationsOtherHouse.json");
import VariableInUse from "@/components/VariableInUse";
import VariableInUseSelector from "@/components/VariableInUseSelector";
import VariableHelpers from "@/assets/js/variableHelpers.js";
import IconBase from "@/components/icons/IconBase";
import IconStar from "@/components/icons/IconStar";
import demoHelper from "../assets/js/demoHelper";
export default {
  data() {
    return {
      filter: "",
      eraser: false,
      showTemplateDataPopover: false,
      // variantVariations: variations
    };
  },
  methods: {
    toggleFavorite(dataSet) {
      this.$store.dispatch("toggleFavorites", dataSet);
    },
    onEraseFilter(filter) {
      this.filter = "";
      filter = "";
      this.onFilterChange(filter);
    },

    onFilterChange(filter) {
      if (this.filter == "") {
        this.eraser = false;
      }
      if (this.filter != "") {
        this.eraser = true;
      }
    },
    getDemoVariations(){
      console.log(this.$store.state.demoData.metadata.demoType)
      console.log(demoHelper.getVariantVariationSets(this.$store.state.demoData.metadata.demoType))
      // this.variantVariations = demoHelper.getVariantVariationSets(this.$store.state.demoData.metadata.demoType)
    }
  },
  computed: {
    variablesInTemplate() {
      // let vars = this.$store.state.templateSectionBeingEdited
      //   ? VariableHelpers.countVariablesInTemplate({ sections: [this.$store.state.templateSectionBeingEdited] })
      //   : VariableHelpers.countVariablesInTemplate(this.$store.state.template);
      // return vars;
      return VariableHelpers.countVariablesInTemplate(this.$store.state.template)	
    },
    dataName: function() {
      return this.$store.state.templateDataSearchResults.find((item) => item.id === this.$store.state.currentDatasetId);
    },
    currentDataSet() {
      return (
        this.$store.state.templateDataSearchResults.find((item) => item.id === this.$store.state.currentDatasetId) ||
        this.$store.state.dataFavorites.find((item) => item.id === this.$store.state.currentDatasetId)
      );
    },
    favoriteDatasets() {
      return this.$store.state.dataFavorites;
    },
    selectedDataset() {
      return this.$store.state.selectedDataset;
    },
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    },
    demoIsOther() {
      return this.$store.state.demoData && this.$store.state.demoData.metadata.demoType.toLowerCase().includes("other")
    },
    variantVariations(){
      return demoHelper.getVariantVariationSets(this.$store.state.demoData.metadata.demoType) 
    }
  },
  // created(){

  //     let usedVars = Object.keys(this.variablesInTemplate).length
  //     console.log("Number of variables already in use!" , usedVars )
  //     let templateNames =  this.$store.state.templateVariables.map(v => v.displayName)
  //     console.log("Number of total variables in dataset!" , templateNames.length )
  //     let varProgress =  `${usedVars} variables out of ${templateNames.length} used `
  // 	console.log(varProgress)

  // 	EventBus.$emit('usedVars', usedVars);
  // 	EventBus.$emit('allVars', templateNames.length);

  // },
  created() {
    this.$store.state.selectedDataset = null;
  },
  mounted(){
    console.log("Variable sidemenu mounted")
    if(this.isDemo) this.getDemoVariations()
  },
  
  components: {
    VariableInUse,
    VariableInUseSelector,
    IconBase,
    IconStar
  }
};
</script>

<style lang="less">
.template-data-popover-toggle {
  position: relative;
}
.data-name-ref-title {
  font-family: "Roboto", sans-serif !important;
  text-transform: unset !important;
  color: #fff;
  padding: 0 45px;
  font-size: 18px;
  font-weight: 900;
}
.data-name-ref {
  color: #fff;
  margin-left: 4px;
  font-size: 15px;
  margin-bottom: 30px;
}
.filter-variables-wrap {
  position: relative;
  margin: 10px 45px 0;
  display: flex;
  align-items: center;

  .filter-variables {
    width: 100%;
    background: transparent;
    border: 0;
    padding-left: 12px;
    height: 30px;
    outline: none;
    color: #fff;

    &::placeholder {
      color: #fff;
    }
  }

  .filter-variables-icon {
    color: #fff;
    // position: absolute;
    // left: 0;
    // top: 9px;
    // width: 15px;
  }

  .search-wrap {
    display: flex;
    flex-direction: row;

    svg {
      color: #fafafa;
      align-self: center;
    }
  }
}
.variables-in-use-wrapper {
  border-bottom: 1px solid #485258; padding-bottom:10px;
  max-height: calc(60vh - 30px); 
}
</style>
